// Main JS goes here
var base = {
	init: function () {
		var self = this;

		// Get user agent info and set as html data-attributes
		// This is for custom styling/bug fixes for specific browser versions
		var el = document.documentElement,
			userAgent = navigator.userAgent;

		el.setAttribute('data-useragent', userAgent);
		el.setAttribute('data-platform', navigator.platform);

		// Fix IOS click delays
		FastClick.attach(document.body);

		// Test for css hover
		Modernizr.addTest('ios', function () {
			return navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
		});

		// Test for lame iPhone-X
		var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && !window.MSStream,
			ratio = window.devicePixelRatio || 1,
			screen = {
				width: window.screen.width * ratio,
				height: window.screen.height * ratio
			};

		if (iOS && screen.width == 1125 && screen.height === 2436) {
			$('html').addClass('iphone-x');
		}

		$('.lazy').lazy({
			visibleOnly: true,
			effect: 'fadeIn',
			effectTime: 125
		});

		$('[data-alt-img]').each(function() {
			var img = $(this);
			img.css('background-image', 'url(' + img.data('alt-img') + ')');
		});

		$('[data-src].lazy').each(function() {
			var img = $(this);
			img.css('background-image', 'url(' + img.data('src') + ')');
		});

		// Protect _blank attacks
		$('a[target=_blank]').each(function () {
			var rel = $(this).attr('rel');

			if (typeof rel === typeof undefined || rel === false) {
				$(this).attr('rel', 'noopener noreferrer');
			} else {
				$(this).attr('rel', $(this).attr('rel') + ' noopener noreferrer');
			}
		});

		// Password protection page
		$('a[href="#Login"]').on('click', function () {
			$('html').toggleClass('login-active');
		});

		if (window.location.hash) {
			var hash = window.location.hash;

			if (hash == '#Login') {
				$('html').addClass('login-active');
			}
		}

		var errors = $('#Login .errors');
		if (errors && errors.length) {
			$('html').addClass('login-active');
		}

		// Sticky Header
    (function(){
			var header = $('[data-header]'),
				body = $('body'),
				html = $('html');

			if (header.length < 1) return

			var content = header.find('[data-header-content]'),
					panel = header.find('[data-header-promo-banner]');

			$(window).on('resize scroll', function () {
				var contentOffset = content.offset().top,
						windowTop = $(window).scrollTop(),
						position = Math.ceil(contentOffset - windowTop),
						panelHeight = panel.length ? panel.outerHeight() : 0,
						headerHeight = header.outerHeight();

				// Scroll Down
				if (position <= 0) {
					body.css('margin-top', headerHeight);
					html.addClass('header-fixed');
					header.css('margin-top', -panelHeight);
				}

				// Scroll Up
				if (windowTop <= panelHeight) {
					body.css('margin-top', '');
					html.removeClass('header-fixed');
					header.css('margin-top', '');
				}

				// Home Page (Fixed Header on Init)
				if (body.hasClass('template-index')) {
					if (self.getBreakpoint() < 768) {
						body.css('margin-top', headerHeight);
					} else {
						body.css('margin-top', panelHeight);
					}

					if (windowTop <= panelHeight) {
						header.css('margin-top', -windowTop);
					} else {
						header.css('margin-top', -panelHeight);
					}
				}

				// Scrolled Desktop Header
				var addTransition = function () {
					html.addClass('header-transition');

					setTimeout(function () {
						html.removeClass('header-transition');
					}, 300);
				};

				if (windowTop > (110 + panelHeight)) {
					if (!html.hasClass('header-scrolled')) {
						html.addClass('header-scrolled');
						addTransition();
					}
				} else {
					if (html.hasClass('header-scrolled')) {
						html.removeClass('header-scrolled');
						addTransition();
					}
				}
			}).resize();

    })();

		// Rotating header
		if ($('[data-header-announcement] li').length) {
			var announcements = $('[data-header-announcement] li');
			var activeClass = 'header-announcement__item--active'

			announcements.first().addClass(activeClass);

			setInterval(function () {
				var active = announcements.filter('.' + activeClass).first();
				var next = active.next('li').length ? active.next('li') : announcements.first();

				active.removeClass(activeClass)
				setTimeout(function () {
					next.addClass(activeClass)
				}, 300);

			}, 5000);
		}

		// Nav tools hover
		$('[data-hover]').each(function () {
			var el = $(this),
				val = el.data('hover');

			el.on('mouseenter', function () {
				el.addClass('hover');
			});

			el.on('mouseleave', function () {
				el.removeClass('hover');
			});

			if (val != 'cart') {
				el.on('touchstart', function () {
					el.toggleClass('hover');
				});
			}
		});

		// External links
		$('.featured-founders-links a').each(function () {
			var link = $(this),
				value = link.attr('href');

			if (value.match(/^http([s]?):\/\/.*/)) {
				link.attr('target', '_blank').attr('rel', 'noopener noreferrer');
			}
		});

		// Alternate product wall image
		$('[data-alternate-image]')
		.on('mouseenter', function () {
			$(this).addClass('collection-image--hover');
		})
		.on('mouseleave', function () {
			$(this).removeClass('collection-image--hover');
		});

		// Collections sort
		var getUrlSortByValue = function () {
			if (window.location.href.indexOf('?') !== -1) {
				var params = window.location.search;
				if (params.indexOf('sort_by') !== -1) {
					var sort = params.slice(params.indexOf('sort_by') + 1).split('=');

					if (typeof (Storage) !== 'undefined') {
						sessionStorage.setItem('sort_by', sort[1]);
					}

					return sort[1];
				}
			} else {
				var el = $('[data-collection-sort-value]').first(),
					value = el.data('collection-sort-value');

				if (typeof (Storage) !== 'undefined' && typeof (sessionStorage.sort_by) !== 'undefined') {
					sessionStorage.removeItem('sort_by');
				}

				return value;
			}
		};

		$('[data-collection-sort-value]').each(function () {
			var el = $(this),
				value = el.data('collection-sort-value');

			if (value == getUrlSortByValue()) {
				el.addClass('collection-sort__item--active');
				return false
			}
		});

		// Quickview
		if ($('[data-quickview-id]').length) {
			var container = '<article id="quickview" class="loading">' +
				'<div class="quickview-container"></div>' +
				'<button type="button" title="Close" data-quickview-close class="quickview__close">Close</button>' +
				'<div class="quickview-controls">' +
				'<button type="button" title="Previous Item" class="quickview__control quickview__control--previous">Previous</button>' +
				'<button type="button" title="Next Item" class="quickview__control quickview__control--next">Next</button>' +
				'</div>' +
				'</article>';

			if (!$('#quickview').length) {
				$('body').append(container);
			}

			$(document).keydown(function (e) {
				switch (e.which) {
					case 37:
						$('#quickview .quickview__control--previous').trigger('click');
						break;
					case 39:
						$('#quickview .quickview__control--next').trigger('click');
						break;
					case 27:
						$('#quickview .quickview__close').trigger('click');
						break;
				}

				if ($.inArray(e.which, [27, 37, 39]) >= 0) {
					return false;
				}
			});
		}

		$(document).on('click', '[data-quickview-id]', function () {
			var el = $(this),
				id = el.data('quickview-id'),
				content = $('#' + id).find('[data-quickview-content]'),
				quickview = $('#quickview'),
				target = '#quickview .quickview-container';

			// Set active item
			$('[data-product].js-quickview-active').removeClass('js-quickview-active');
			el.closest('[data-product]').addClass('js-quickview-active');

			// Loading
			quickview.addClass('loading');

			// Populate template
			$(target).empty();
			content.clone().appendTo(target);

			// Activate
			$('html').addClass('quickview-active');

			// Lazy load images
			quickview.find('[data-src]').each(function () {
				var img = $(this);
				img.attr('src', img.data('src')).removeAttr('data-src');
			});

			// Listen for images loaded
			quickview.imagesLoaded(function () {
				var margin = $(target).outerHeight() / 2;
				$(target).css('margin-top', -margin + 'px');
				quickview.removeClass('loading');
			});

			return false;
		});

		$(document).on('click', '#quickview .quickview__close', function () {
			$('html').removeClass('quickview-active');
		});

		$(document).on('click', '#quickview .quickview__control--previous', function () {
			var prevItem = $('.js-quickview-active').prevAll('[data-product]').find('[data-quickview-id]').closest('[data-product]').last();
			if (prevItem.length < 1) prevItem = $('.js-quickview-active').closest('[data-products]').find('[data-quickview-id]').closest('[data-product]').last();

			$('#quickview').addClass('loading');

			setTimeout(function () {
				prevItem.find('[data-quickview-id]').trigger('click');
			}, 300);
		});

		$(document).on('click', '#quickview .quickview__control--next', function() {
			var nextItem = $('.js-quickview-active').nextAll('[data-product]').find('[data-quickview-id]').closest('[data-product]').first();
			if (nextItem.length < 1) nextItem = $('.js-quickview-active').closest('[data-products]').find('[data-quickview-id]').closest('[data-product]').first();

			$('#quickview').addClass('loading');

			setTimeout(function () {
				nextItem.find('[data-quickview-id]').trigger('click');
			}, 300);
		});

		// PDP increment quantity
		$('body').on('click', '[data-increment]', function () {
			var el = $(this),
				direction = el.data('increment'),
				input = $('[data-increment-quantity]');

			input.val(function (i, val) {
				if (direction == 'plus') {
					return ++val;
				} else if (direction == 'minus') {
					if (val > 1) {
						return --val;
					} else {
						return 1;
					}
				} else {
					return val;
				}
			});
		});

		// PDP Slick slider
		$(window).on('load, resize', function () {
			var slider = $('[data-slick-product]'),
				options = {
					draggable: false,
					infinite: false,
					mobileFirst: true,
					slidesToScroll: 1,
					slidesToShow: 1,
					speed: 300
				};

			if (self.getBreakpoint() < 768) {
				if (!slider.hasClass('slick-initialized')) {
					slider.slick(options);
				}
			} else {
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
			}
		}).resize();

		$(document).on('click', '[data-slick-product-thumb]', function () {
			var el = $(this),
				slideIndex = el.data('slick-product-thumb');

			$('[data-slick-product]').slick('slickGoTo', slideIndex);
			return false;
		});

		$(document).on('click', '[data-product-thumb-id]', function () {
			var el = $(this),
				id = el.data('product-thumb-id');

			scrollToAnchor(id);
			return false;
		});

		// Mini Cart
		var currency = (typeof miniCart !== 'undefined') ? miniCart.currency : 'USD',
			locale = (typeof miniCart !== 'undefined') ? miniCart.locale : 'en-US';

		self.formatter = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: 2
		});

		$(document).on('click', '[data-add-to-cart]', function () {
			$(this).trigger('igk:addtocart');
			if (self.getBreakpoint() >= 768) {
				self.updateCart($(this));
				return false;
			}

			// Frizz Quiz Page
			if (typeof $(this).closest('[data-frizz-quiz-result]') !== 'undefined') {
				self.updateCart($(this));
				return false;
			}
		});

		$(document).on('mouseenter', '[data-hover="cart"]', function () {
			if (self.getBreakpoint() >= 768) {
				var active = $(this).find('.mini-cart--active');

				if (typeof active !== 'undefined') {
					active.removeClass('mini-cart--active');
				}
			}
		});

		// Account Addresses
		$('[data-edit-address]').on('click', function () {
			$(this).closest('li').toggleClass('active');
		});

		// Blog Wall
		$(window).on('load', function () {
			$('.blog-post-holder').masonry({
				itemSelector: '.blog-post__article',
				percentPosition: true,
				transitionDuration: 0,
				gutter: 0
			});
		});

		// Blog Detail
		$('[data-blog-detail-html]').each(function () {
			var container = $('[data-blog-detail]'),
				content = $(this),
				firstTag = content.find('p:first'),
				firstElement = firstTag.children().first(),
				hero = $('[data-blog-detail-hero-image]'),
				options = $('[data-blog-detail-options]');

			if (firstElement.is('img') && typeof hero !== "undefined") {
				container.addClass('blog-detail--hero');
				options.addClass('blog-detail-options--hero');

				hero.append(firstTag);

				var image = hero.find('img');

				if (image.parent().is('p')) {
					image.unwrap();
				}
			}
		});

		// Remove empty <p></p> tags
		$('[data-blog-detail-html]').find('p').each(function () {
			var tag = $(this);
			if (tag.html().replace(/\s|&nbsp;/g, '').length == 0) {
				tag.remove();
			}
		});

		// Wrap YouTube and Vimeo
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
			var iframe = $(this);
			if (!iframe.parent().hasClass('video')) {
				iframe.wrap('<div class="video"></div>');
			}
		});

		// Wrap images if hero
		$('[data-blog-detail-html] > p').each(function () {
			var el = $(this),
				firstElement = el.children().first(),
				hero = $('[data-blog-detail-hero-image]');

			if (firstElement.is('img') && typeof hero !== "undefined") {
				el.addClass('is-image');
			}
		});

		// Open video on page load
		if (location.search.includes('video=')) {
		  const id = location.search.split('video=')[1]
		  $('[data-fancybox][href*="'+ id.split('&')[0] +'"]').click()[0]
		}

		// Set max-width for fancybox videos
		$('[data-fancybox][data-video-max-width]').fancybox({
			beforeShow: function() {
				$('html').addClass('fancybox-video--has-max-width');
				$('html')[0].style.setProperty('--fancybox-video-max-width', this.opts.videoMaxWidth);
			},
			afterClose: function() {
				$('html').removeClass('fancybox-video--has-max-width');
				$('html')[0].style.setProperty('--fancybox-video-max-width', '100%');
			},
			media : {
				youtube : {
					params : {
						autoplay : 1
					}
				}
			}
		});

		// Background image clip polyfill
		/*
		$(window).on('load', function () {
			$('[data-pattern-bg]').each(function (index) {
				var className = $(this).attr('class'),
					element = document.querySelector('.' + className),
					id = 'pattern-' + index,
					url = $(this).data('pattern-bg');

				if (element !== null) {
					element.backgroundClipPolyfill({
						'patternID': 'pattern',
						'patternURL': url,
						'class': className
					});
				}
			});
		});
		*/

		// About image columns
		$('[data-about-image-column]').each(function () {
			var className = $('[data-about-image-column-list]').attr('class'),
				container = $(this),
				marker = Math.round($('[data-about-image-column-item]').length / 2);

			$('[data-about-image-column-item]').each(function (i) {
				if (i >= marker) {
					$(this).addClass('split');
				}
			});

			$('[data-about-image-column-item].split')
				.insertAfter('[data-about-image-column-list]')
				.wrapAll('<ul class="' + className + ' ' + className + '--2"></ul>')
				.removeClass('split');

			$('[data-about-image-column-list]').addClass(className + '--1');
		});

		// Back to top
		$('[data-back-to-top]').each(function () {
			$(window).on('load resize scroll', function () {
				var documentHeight = $(document).height(),
					scrollDistance = $(document).scrollTop(),
					windowHeight = $(window).height();

				if (documentHeight > windowHeight * 2) {
					if (scrollDistance + windowHeight > documentHeight / 2) {
						$('html').addClass('back-to-top-active');
					} else {
						$('html').removeClass('back-to-top-active');
					}
				}
			}).resize();

			$(this).on('click', function () {
				var scrollDuration = Math.min(Math.max($(document).scrollTop(), $(document).scrollTop()) / ($(document).height() - $(window).height()), 1) * 650;
				$('html, body').animate({ scrollTop: 0 }, { duration: scrollDuration });
			});
		});

		// Smooth Scroll
		var scrollToAnchor = function (hash) {
			var target = $(hash),
				offset = self.getBreakpoint() < 768 ? $('[data-header-content]').outerHeight() : 80;

			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - offset
				}, 750);
			}
		};

		$(document).ready(function () {
			if (window.location.hash) {
				scrollToAnchor(window.location.hash);
			}
		});

		$('a[href^=\\#]:not([href=\\#]):not([data-dont-scroll])').click(function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') || location.hostname == this.hostname) {
				scrollToAnchor(this.hash);
				return false;
			}
		});

		// Tabs
		$('[data-tabs]').each(function () {
			var el = $(this),
				contentNavTab = el.find('[data-content-nav-tab]');

			if (!el.find('[data-tab]').hasClass('active') && !el.find('[data-tab]:first-of-type').hasClass('active')) {
				if (typeof (contentNavTab) !== 'undefined') {
					contentNavTab.first().addClass('active');
				}
				el.find('[data-nav-tab]').first().addClass('active');
				el.find('[data-tab]').first().addClass('active');
			}
		});

		// Toggle tabs with nav button clicks
		$('[data-nav-tab], [data-content-nav-tab]').on('click', function () {
			var el = $(this),
				active = typeof (el.data('content-nav-tab')) !== 'undefined' ? el.data('content-nav-tab') : el.data('nav-tab'),
				container = el.closest('[data-tabs]'),
				content = container.find('[data-tab="' + active + '"]'),
				contentNavTab = container.find('[data-content-nav-tab="' + active + '"]'),
				navTab = container.find('[data-nav-tab="' + active + '"]');

			// Content
			content.addClass('active').siblings('[data-tab]').removeClass('active');

			// Nav content tab (Optional)
			if (typeof (contentNavTab) !== 'undefined') {
				contentNavTab.addClass('active').siblings('[data-content-nav-tab]').removeClass('active');

				if (self.getBreakpoint() < 768) {
					$('html, body').animate({ scrollTop: contentNavTab.offset().top - $('[data-header-content]').outerHeight() }, 0);
				}
			}

			// Nav tab
			navTab.addClass('active').siblings('[data-nav-tab]').removeClass('active');
		});

		// Toggle
		$('[data-toggle-class]').on('click', function () {
			var el = $(this),
				className = el.data('toggle-class'),
				// You can override by setting data-toggle-class-on='any-element'
				target = typeof (el.data('toggle-class-on')) === 'undefined' ? $('html') : $(el.data('toggle-class-on'));

			// Toggle the class
			target.toggleClass(className);
			return false;
		});

		$('[data-toggle-transition]').on('click', function () {
			var el = $(this),
				className = el.data('toggle-transition').class,
				duration = el.data('toggle-transition').duration,
				target = $('html');

			target.addClass(className);

			setTimeout(function () {
				target.removeClass(className);
			}, duration);
		});

		$('[data-toggle]').on('click', function () {
			var toggleMaxWidth = typeof ($(this).data('toggle-max-width')) !== 'undefined' ? $(this).data('toggle-max-width') : null;

			// Toggle if under the data=toggle-max-width, or if there is no data-toggle-max-width set
			if (toggleMaxWidth !== null && self.getBreakpoint() < toggleMaxWidth || toggleMaxWidth === null) {
				self.dataToggle($(this));
				return false;
			}
		});

		    $('[data-offers-slider]').slick({
      prevArrow: '<svg id="previous" class="slick-prev" width="9px" height="15px" viewBox="0 0 9 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Offer-Tab" transform="translate(-18.000000, -110.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-18" transform="translate(2.000000, 2.000000)"><g id="Group-17" transform="translate(16.000000, 77.000000)"><polygon id="Shape-Copy-4" points="9 44.2375 3.43724696 38.5 9 32.7625 7.28744939 31 0 38.5 7.28744939 46"></polygon></g></g></g></g></svg>',
      nextArrow: '<svg id="next" class="slick-next" width="7px" height="12px" viewBox="0 0 7 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Offer-Tab" transform="translate(-312.000000, -111.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-18" transform="translate(2.000000, 2.000000)"><g id="Group-17" transform="translate(16.000000, 77.000000)"><polygon id="Shape-Copy-5" transform="translate(297.500000, 38.000000) rotate(-180.000000) translate(-297.500000, -38.000000) " points="301 42.59 296.673414 38 301 33.41 299.668016 32 294 38 299.668016 44"></polygon></g></g></g></g></svg>'
    })

    const $offersBtn = $('[data-offers-tab-btn]')
    const $offersHide = $('[data-offers-tab-hide]')
    const $offersContainer = $('[data-offers-tab-container]')

    if (!Cookies.get('offers-tab-hidden')) {
      $offersContainer.removeClass('hidden')
    }

    $offersBtn.on('click', function() {
      $offersContainer.toggleClass('active')
    })

    $offersHide.on('click', function() {
      $offersContainer.toggleClass('hidden')

      // add a session cookie to keep offers tab hidden
      Cookies.set('offers-tab-hidden', 'true')
    })

    $(document).on('click', function(e) {
      if (!$(e.target).closest('[data-offers-tab-container]').length) {
        $offersContainer.removeClass('active')
      }
    })

		// Remove stop words from the search terms
		$('.header-search').on('submit', function(e){
			var search = [];
			var searchField = $(this).find('.header-search__input');
			var searchTerms = searchField.val().split(' ');
			var stopwords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't", "&"];
			search = $(searchTerms).not(stopwords).get();
			searchField.val(search.join(' '));
		});

    // Add Collection to Cart
    var addCollection = function (array) {
      var headerCartCount = $('[data-header-cart-count]'),
        headerCartQuantity = parseFloat(headerCartCount.text()),
        submit = $('[data-add-all-to-cart]');

      submit.addClass('loading').prop('disabled', true);

      addItem = function () {
        if (array.length) {
          var variant = array.shift(),
            data = {};

          data.id = parseFloat(variant);
          data.quantity = 1;

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function (result) {
              headerCartQuantity += 1;
              addItem();
            },
            error: function () {
              if (array.length) {
                addItem();
              } else {
                headerCartCount.text(headerCartQuantity);
                submit.removeClass('loading').prop('disabled', false);
              }
            }
          });
        } else {
          headerCartCount.text(headerCartQuantity);
          submit.removeClass('loading').prop('disabled', false);
          self.updateMiniCart();
        }
      };

      addItem();
    };

    // Add Collection to Cart Button
    $(document).on('click', '[data-add-all-to-cart]', function () {
      addCollection($(this).data('add-all-to-cart').split(','));
      if ($(this).data('discount-code')) {
        Cookies.set('discount_code', $(this).data('discount-code'))
      }
    });
	},
	getBreakpoint: function () {
		var breakpoint;
		if (window.getComputedStyle) {
			breakpoint = window.getComputedStyle(
				document.querySelector('body'), ':before'
			).getPropertyValue('content');

			breakpoint = parseInt(breakpoint.replace("'", "").replace('"', ''));
		} else { // IE8 fallback
			breakpoint = $(window).width();
		}
		return breakpoint;
	},
	dataToggle: function (e) {
		var speed = 400,
			toggleData = e.data('toggle'),
			container = e.closest(':has(' + toggleData + ')');

		// Toggle siblings (if [data-siblings] is set)
		if (e.data('toggle-siblings')) {
			var siblings = e.closest(e.data('toggle-siblings')).siblings().find(toggleData);
			siblings.slideUp(speed).closest('.active-toggle').removeClass('active-toggle');
		}

		// Toggle element
		e.closest(container).toggleClass('active-toggle').find(toggleData).slideToggle(speed);
	},
	updateCart: function ($this) {
		var self = this;

		var button = $this,
			form = button.closest('form'),
			miniCart = $('[data-minicart]'),
			isCartPage = miniCart.hasClass('mini-cart--cart-page');

		form.addClass('activeForm')

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: form.serialize(),
			success: function (result) {
				if (result) {
					if (isCartPage) {
						window.location.reload();
						return
					}

					self.updateMiniCart()
				}
			},
			error: function (jqXHR, exception) {
				var msg;

				if (jqXHR.status === 0) {
					msg = 'Not connect.\n Verify Network.';
				} else if (jqXHR.status == 404) {
					msg = 'Requested page not found. [404]';
				} else if (jqXHR.status == 500) {
					msg = 'Internal Server Error [500].';
				} else if (exception === 'parsererror') {
					msg = 'Requested JSON parse failed.';
				} else if (exception === 'timeout') {
					msg = 'Time out error.';
				} else if (exception === 'abort') {
					msg = 'Ajax request aborted.';
				} else {
					msg = 'Uncaught Error.\n' + jqXHR.responseText;
				}

				alert(msg);
			}
		});
	},
	itemPricesConverted: function (item) {
		var self = this

		// Convert prices to currency
		item.price_unconverted = self.formatter.format(item.final_price / 100);
		item.price_converted = item.price_unconverted.replace('.00', '');
		item.original_price_unconverted = self.formatter.format(item.original_price / 100);
		item.original_price_converted = item.original_price_unconverted.replace('.00', '');

		// If sale price
		if (item.original_line_price != item.line_price) {
			item.price_converted = item.price_converted + ' <s>' + item.original_price_converted + '</s>';
		}

		return item
	},
	updateMiniCart: function () {
		var self = this,
			itemTemplate = $('[data-minicart-item-template]'),
			template = $('[data-minicart-template]'),
			currency = (typeof miniCart !== 'undefined') ? miniCart.currency : 'USD',
			locale = (typeof miniCart !== 'undefined') ? miniCart.locale : 'en-US';

		formatter = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: 2
		});

		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',
			success: function (result) {
				if ($('[data-minicart] form').length == 0) {
					// Remove empty cart message
					var empty = $('[data-minicart-empty]');
					if (empty.length) {
						empty.remove();
					}
					// Insert form and 1st variant
					var item = result.items.shift();
					item = self.itemPricesConverted(item)
					template.tmpl(item).appendTo('[data-minicart]');
				} else {
					// Form exists so empty results for insert below
					var minicartList = $('[data-minicart-list]');
					if (minicartList.length) {
						minicartList.empty();
					}
				}

				// Insert results
				$.each(result.items, function (index, item) {
					item = self.itemPricesConverted(item)
					itemTemplate.tmpl(item).prependTo('[data-minicart-list]');
				});

				// Update Subtotal
				var subtotal = $('[data-minicart-subtotal]');
				subtotal.text(formatter.format(result.items_subtotal_price / 100));

				// Handle shipping promo
				var freeShippingAmount = (typeof freeShipping !== 'undefined') ? parseFloat(freeShipping.amount) : 0;
				if (freeShippingAmount > 0 && result.items_subtotal_price < freeShippingAmount) {
					var difference = freeShippingAmount - result.items_subtotal_price;

					$('[data-promo="minicart"]').removeClass('hidden');
					$('[data-shipping-promo]').toggleClass('hidden');
					$('[data-promo-difference]').text(self.formatter.format(difference / 100));
				} else {
					$('[data-promo="minicart"]').addClass('hidden');
					$('[data-cart-sidebar-shipping]').text('FREE');
					$('[data-shipping-promo]').toggleClass('hidden');
				}

				// Update header cart count
				headerCartCount = $('[data-header-cart-count]')
				if (headerCartCount.length) headerCartCount.text(result.item_count);

				// Close quickview
				var html = $('html');
				if (html.hasClass('quickview-active')) {
					$('[data-quickview-close]').trigger('click');
				}

				// Display minicart
				var minicart = $('[data-hover="cart"]');
				minicart.addClass('hover');

				setTimeout(function () {
					minicart.removeClass('hover');
				}, 6000);
			},
			error: function () {}
		});
	}
};

$(function () {
	base.init();
});
